<template>
  <div class="feedback">
    <div class="feedback-conten">
      <form v-on:submit.prevent="submitForm">
        <div class="tip">
          <p>{{$t('join_1')}}</p>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>{{$t('join_2')}}</label>
            <div>
              <input type="text" :placeholder="$t('join_3')" v-model="formData.name">
            </div>
          </div>
          <div class="col-md-6">
            <label>{{$t('join_4')}}</label>
            <div class="chekox-box2">
              <div>
                <input type="radio" id="female" value="男性" v-model="formData.gender">
                <label for="female">{{$t('join_5')}}</label>
              </div>
              <div>
                <input type="radio" id="male" value="女性" v-model="formData.gender">
                <label for="male">{{$t('join_6')}}</label>
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>{{$t('join_7')}}</label>
            <div>
              <input type="text" :placeholder="$t('join_8')" v-model="formData.age">
            </div>
          </div>
          <div class="col-md-6">
            <label>{{$t('join_9')}}</label>
            <div>
              <input type="text" :placeholder="$t('join_10')" v-model="formData.phone">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>{{$t('join_11')}}</label>
            <div>             
              <vue-select v-model="formData.joinArea" v-bind:list="address"></vue-select>
            </div>
          </div>
          <div class="col-md-6">
            <label>{{$t('join_12')}}</label>
            <div class="chekox-box2">
              <div>
                <input type="radio" id="married" value="已婚" v-model="formData.marriageStatus">
                <label for="married">{{$t('join_13')}}</label>
              </div>
              <div>
                <input type="radio" id="unmarried" value="未婚" v-model="formData.marriageStatus">
                <label for="unmarried">{{$t('join_14')}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 m-mb-23">
            <label for="">{{$t('join_15')}}</label>
            <div>
              <input type="text" :placeholder="$t('join_16')" v-model="formData.mail">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label>{{$t('join_17')}}</label>
            <section class="address-box">
              <div class="col-md-4">
                <vue-select v-model="formData.city" tip="join_21" v-bind:list="address" v-on:valueChanged="changeCity"></vue-select>
              </div>
              <div class="col-md-4">
                <vue-select v-model="formData.area" tip="join_22" v-bind:list="areaList"></vue-select>
              </div>
              <div class="col-md-4">
                <input type="text" :placeholder="$t('join_18')" v-model="formData.zipcode">
              </div>
            </section>
          </div>
          <div class="col-md-12 m-mb-23">
            <label for=""></label>
            <div class="mt-35">
              <input type="text" :placeholder="$t('join_19')" v-model="formData.address">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 m-mb-23">
            <label for="">{{$t('join_20')}}</label>
            <div>
              <textarea name="" id="" cols="100" rows="50" :placeholder="$t('join_20')" v-model="formData.content"></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>{{ $t('contact_14') }}</label>
            <div class="graphic" v-if="graphicId" :class="{'error': isSubmit && (!formData.verificationcode || isGraphicError)}">
              <input type="text" :placeholder="$t('contact_72')" v-model="formData.verificationcode" @change="()=>{this.isGraphicError = false}">
              <img :src="graphic + graphicId">
              <a class="reload-img" @click="getGraphicId()"></a>
              <p class="error-tip" v-if="isGraphicError || (isSubmit && !formData.verificationcode)">{{$t('contact_72')}}</p>
            </div>
          </div>
        </div>
        <div class="agree">
          <label class="agree-box">
            <div>
              <input type="checkbox" id="agree" name="agree" v-model="isAgree">
              <label for="agree"></label>
              <span><a href="#" @click.prevent="openClausePopUp()" class="agree-link" :class="{'gray':!isAgree}">{{ $t('contact_15') }}</a></span>
            </div>
          </label>
          <div class="error" v-if="isSubmit && !isAgree">
            <p class="error-tip">{{$t('check')}}</p>
          </div>
        </div>
        <div class="agree-submit-btn">
          <button type="submit" class="agree-submit">{{ $t('contact_16') }}</button>
        </div>


      </form>
    </div>
    <clausePopup v-if="isShowClause" v-bind:text="text" v-on:closeChanged="closePopup"></clausePopup>

    <div class="popup-ok" v-if="isShowPopup">
      <div class="box">
        <h2>{{$t('feedbackTitle')}}</h2>
        <p>{{$t('feedbackTip')}}</p>
        <div class="btn-box">
          <button class="ok-submit" @click="()=>{this.isShowPopup=false;}">{{$t('ok')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "../config/api";
import ClausePopup from "./clausePopup";
import VueSelect from "./vue-select";

export default {
  name: 'Feedback',
  data() {
    return {
      address: [        
        {
          name: '基隆市',
          code: '基隆市',
          children: [
            {name: '請選擇區域', code: ''},
            {name: '仁愛區', code: '仁愛區'},
            {name: '中正區', code: '中正區'},
            {name: '信義區', code: '信義區'},
            {name: '中山區', code: '中山區'},
            {name: '安樂區', code: '安樂區'},
            {name: '暖暖區', code: '暖暖區'},
            {name: '七堵區', code: '七堵區'},
          ]
        },
        {
          name: '台北市',
          code: '台北市',
          children: [
            {name: '請選擇區域', code: ''},
            {name: '中正區', code: '中正區'},
            {name: '大同區', code: '大同區'},
            {name: '中山區', code: '中山區'},
            {name: '松山區', code: '松山區'},
            {name: '大安區', code: '大安區'},
            {name: '萬華區', code: '萬華區'},
            {name: '信義區', code: '信義區'},
            {name: '士林區', code: '士林區'},
            {name: '北投區', code: '北投區'},
            {name: '內湖區', code: '內湖區'},
            {name: '南港區', code: '南港區'},
            {name: '文山區', code: '文山區'},
          ]
        },
        {
          name: '新北市',
          code: '新北市',
          children: [
            {name: '請選擇區域', code: ''},
            {name: '板橋區', code: '板橋區'},
            {name: '新莊區', code: '新莊區'},
            {name: '中和區', code: '中和區'},
            {name: '永和區', code: '永和區'},
            {name: '土城區', code: '土城區'},
            {name: '樹林區', code: '樹林區'},
            {name: '三峽區', code: '三峽區'},
            {name: '鶯歌區', code: '鶯歌區'},
            {name: '三重區', code: '三重區'},
            {name: '蘆洲區', code: '蘆洲區'},
            {name: '五股區', code: '五股區'},
            {name: '泰山區', code: '泰山區'},
            {name: '林口區', code: '林口區'},
            {name: '八里區', code: '八里區'},
            {name: '淡水區', code: '淡水區'},
            {name: '三芝區', code: '三芝區'},
            {name: '石門區', code: '石門區'},
            {name: '金山區', code: '金山區'},
            {name: '萬里區', code: '萬里區'},
            {name: '汐止區', code: '汐止區'},
            {name: '瑞芳區', code: '瑞芳區'},
            {name: '貢寮區', code: '貢寮區'},
            {name: '平溪區', code: '平溪區'},
            {name: '雙溪區', code: '雙溪區'},
            {name: '新店區', code: '新店區'},
            {name: '深坑區', code: '深坑區'},
            {name: '石碇區', code: '石碇區'},
            {name: '坪林區', code: '坪林區'},
            {name: '烏來區', code: '烏來區'},
          ]
        },
        {
          name: '桃園市',
          code: '桃園市',
          children: [
            {name: '請選擇區域', code: ''},
            {name: '桃園區', code: '桃園區'},
            {name: '中壢區', code: '中壢區'},
            {name: '平鎮區', code: '平鎮區'},
            {name: '八德區', code: '八德區'},
            {name: '楊梅區', code: '楊梅區'},
            {name: '蘆竹區', code: '蘆竹區'},
            {name: '大溪區', code: '大溪區'},
            {name: '龍潭區', code: '龍潭區'},
            {name: '龜山區', code: '龜山區'},
            {name: '大園區', code: '大園區'},
            {name: '觀音區', code: '觀音區'},
            {name: '新屋區', code: '新屋區'},
            {name: '復興區', code: '復興區'},
          ]
        },
        {
          name: '新竹市',
          code: '新竹市',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "東區", "code": "東區"},
            {"name": "北區", "code": "北區"},
            {"name": "香山區", "code": "香山區"}
          ]
        },
        {
          name: '新竹縣',
          code: '新竹縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "竹北市", "code": "竹北市"},
            {"name": "竹東鎮", "code": "竹東鎮"},
            {"name": "新埔鎮", "code": "新埔鎮"},
            {"name": "關西鎮", "code": "關西鎮"},
            {"name": "湖口鄉", "code": "湖口鄉"},
            {"name": "新豐鄉", "code": "新豐鄉"},
            {"name": "峨眉鄉", "code": "峨眉鄉"},
            {"name": "寶山鄉", "code": "寶山鄉"},
            {"name": "北埔鄉", "code": "北埔鄉"},
            {"name": "芎林鄉", "code": "芎林鄉"},
            {"name": "橫山鄉", "code": "橫山鄉"},
            {"name": "尖石鄉", "code": "尖石鄉"},
            {"name": "五峰鄉", "code": "五峰鄉"}
          ]
        },
        {
          name: '苗栗縣',
          code: '苗栗縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "苗栗市", "code": "苗栗市"},
            {"name": "頭份市", "code": "頭份市"},
            {"name": "竹南鎮", "code": "竹南鎮"},
            {"name": "後龍鎮", "code": "後龍鎮"},
            {"name": "通霄鎮", "code": "通霄鎮"},
            {"name": "苑裡鎮", "code": "苑裡鎮"},
            {"name": "卓蘭鎮", "code": "卓蘭鎮"},
            {"name": "造橋鄉", "code": "造橋鄉"},
            {"name": "西湖鄉", "code": "西湖鄉"},
            {"name": "頭屋鄉", "code": "頭屋鄉"},
            {"name": "公館鄉", "code": "公館鄉"},
            {"name": "銅鑼鄉", "code": "銅鑼鄉"},
            {"name": "三義鄉", "code": "三義鄉"},
            {"name": "大湖鄉", "code": "大湖鄉"},
            {"name": "獅潭鄉", "code": "獅潭鄉"},
            {"name": "三灣鄉", "code": "三灣鄉"},
            {"name": "南庄鄉", "code": "南庄鄉"},
            {"name": "泰安鄉", "code": "泰安鄉"}
          ]
        },
        {
          name: '台中市',
          code: '台中市',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "中區", "code": "中區"},
            {"name": "東區", "code": "東區"},
            {"name": "南區", "code": "南區"},
            {"name": "西區", "code": "西區"},
            {"name": "北區", "code": "北區"},
            {"name": "北屯區", "code": "北屯區"},
            {"name": "西屯區", "code": "西屯區"},
            {"name": "南屯區", "code": "南屯區"},
            {"name": "太平區", "code": "太平區"},
            {"name": "大里區", "code": "大里區"},
            {"name": "霧峰區", "code": "霧峰區"},
            {"name": "烏日區", "code": "烏日區"},
            {"name": "豐原區", "code": "豐原區"},
            {"name": "后里區", "code": "后里區"},
            {"name": "石岡區", "code": "石岡區"},
            {"name": "東勢區", "code": "東勢區"},
            {"name": "新社區", "code": "新社區"},
            {"name": "潭子區", "code": "潭子區"},
            {"name": "大雅區", "code": "大雅區"},
            {"name": "神岡區", "code": "神岡區"},
            {"name": "大肚區", "code": "大肚區"},
            {"name": "沙鹿區", "code": "沙鹿區"},
            {"name": "龍井區", "code": "龍井區"},
            {"name": "梧棲區", "code": "梧棲區"},
            {"name": "清水區", "code": "清水區"},
            {"name": "大甲區", "code": "大甲區"},
            {"name": "外埔區", "code": "外埔區"},
            {"name": "大安區", "code": "大安區"},
            {"name": "和平區", "code": "和平區"}
          ]
        },
        {
          name: '彰化縣',
          code: '彰化縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "彰化市", "code": "彰化市"},
            {"name": "員林市", "code": "員林市"},
            {"name": "和美鎮", "code": "和美鎮"},
            {"name": "鹿港鎮", "code": "鹿港鎮"},
            {"name": "溪湖鎮", "code": "溪湖鎮"},
            {"name": "二林鎮", "code": "二林鎮"},
            {"name": "田中鎮", "code": "田中鎮"},
            {"name": "北斗鎮", "code": "北斗鎮"},
            {"name": "花壇鄉", "code": "花壇鄉"},
            {"name": "芬園鄉", "code": "芬園鄉"},
            {"name": "大村鄉", "code": "大村鄉"},
            {"name": "永靖鄉", "code": "永靖鄉"},
            {"name": "伸港鄉", "code": "伸港鄉"},
            {"name": "線西鄉", "code": "線西鄉"},
            {"name": "福興鄉", "code": "福興鄉"},
            {"name": "秀水鄉", "code": "秀水鄉"},
            {"name": "埔心鄉", "code": "埔心鄉"},
            {"name": "埔鹽鄉", "code": "埔鹽鄉"},
            {"name": "大城鄉", "code": "大城鄉"},
            {"name": "芳苑鄉", "code": "芳苑鄉"},
            {"name": "竹塘鄉", "code": "竹塘鄉"},
            {"name": "社頭鄉", "code": "社頭鄉"},
            {"name": "二水鄉", "code": "二水鄉"},
            {"name": "田尾鄉", "code": "田尾鄉"},
            {"name": "埤頭鄉", "code": "埤頭鄉"},
            {"name": "溪州鄉", "code": "溪州鄉"}
          ]
        },
        {
          name: '南投縣',
          code: '南投縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "南投市", "code": "南投市"},
            {"name": "埔里鎮", "code": "埔里鎮"},
            {"name": "草屯鎮", "code": "草屯鎮"},
            {"name": "竹山鎮", "code": "竹山鎮"},
            {"name": "集集鎮", "code": "集集鎮"},
            {"name": "名間鄉", "code": "名間鄉"},
            {"name": "鹿谷鄉", "code": "鹿谷鄉"},
            {"name": "中寮鄉", "code": "中寮鄉"},
            {"name": "魚池鄉", "code": "魚池鄉"},
            {"name": "國姓鄉", "code": "國姓鄉"},
            {"name": "水里鄉", "code": "水里鄉"},
            {"name": "信義鄉", "code": "信義鄉"},
            {"name": "仁愛鄉", "code": "仁愛鄉"}
          ]
        },
        {
          name: '雲林縣',
          code: '雲林縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "斗六市", "code": "斗六市"},
            {"name": "斗南鎮", "code": "斗南鎮"},
            {"name": "虎尾鎮", "code": "虎尾鎮"},
            {"name": "西螺鎮", "code": "西螺鎮"},
            {"name": "土庫鎮", "code": "土庫鎮"},
            {"name": "北港鎮", "code": "北港鎮"},
            {"name": "林內鄉", "code": "林內鄉"},
            {"name": "古坑鄉", "code": "古坑鄉"},
            {"name": "大埤鄉", "code": "大埤鄉"},
            {"name": "莿桐鄉", "code": "莿桐鄉"},
            {"name": "褒忠鄉", "code": "褒忠鄉"},
            {"name": "二崙鄉", "code": "二崙鄉"},
            {"name": "崙背鄉", "code": "崙背鄉"},
            {"name": "麥寮鄉", "code": "麥寮鄉"},
            {"name": "臺西鄉", "code": "臺西鄉"},
            {"name": "東勢鄉", "code": "東勢鄉"},
            {"name": "元長鄉", "code": "元長鄉"},
            {"name": "四湖鄉", "code": "四湖鄉"},
            {"name": "口湖鄉", "code": "口湖鄉"},
            {"name": "水林鄉", "code": "水林鄉"}
          ]
        },
        {
          name: '嘉義市',
          code: '嘉義市',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "東區", "code": "東區"},
            {"name": "西區", "code": "西區"}
          ]
        },
        {
          name: '嘉義縣',
          code: '嘉義縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "太保市", "code": "太保市"},
            {"name": "朴子市", "code": "朴子市"},
            {"name": "布袋鎮", "code": "布袋鎮"},
            {"name": "大林鎮", "code": "大林鎮"},
            {"name": "民雄鄉", "code": "民雄鄉"},
            {"name": "溪口鄉", "code": "溪口鄉"},
            {"name": "新港鄉", "code": "新港鄉"},
            {"name": "六腳鄉", "code": "六腳鄉"},
            {"name": "東石鄉", "code": "東石鄉"},
            {"name": "義竹鄉", "code": "義竹鄉"},
            {"name": "鹿草鄉", "code": "鹿草鄉"},
            {"name": "水上鄉", "code": "水上鄉"},
            {"name": "中埔鄉", "code": "中埔鄉"},
            {"name": "竹崎鄉", "code": "竹崎鄉"},
            {"name": "梅山鄉", "code": "梅山鄉"},
            {"name": "番路鄉", "code": "番路鄉"},
            {"name": "大埔鄉", "code": "大埔鄉"},
            {"name": "阿里山鄉", "code": "阿里山鄉"}
          ]
        },
        {
          name: '台南市',
          code: '台南市',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "中西區", "code": "中西區"},
            {"name": "東區", "code": "東區"},
            {"name": "南區", "code": "南區"},
            {"name": "北區", "code": "北區"},
            {"name": "安平區", "code": "安平區"},
            {"name": "安南區", "code": "安南區"},
            {"name": "永康區", "code": "永康區"},
            {"name": "歸仁區", "code": "歸仁區"},
            {"name": "新化區", "code": "新化區"},
            {"name": "左鎮區", "code": "左鎮區"},
            {"name": "玉井區", "code": "玉井區"},
            {"name": "楠西區", "code": "楠西區"},
            {"name": "南化區", "code": "南化區"},
            {"name": "仁德區", "code": "仁德區"},
            {"name": "關廟區", "code": "關廟區"},
            {"name": "龍崎區", "code": "龍崎區"},
            {"name": "官田區", "code": "官田區"},
            {"name": "麻豆區", "code": "麻豆區"},
            {"name": "佳里區", "code": "佳里區"},
            {"name": "西港區", "code": "西港區"},
            {"name": "七股區", "code": "七股區"},
            {"name": "將軍區", "code": "將軍區"},
            {"name": "學甲區", "code": "學甲區"},
            {"name": "北門區", "code": "北門區"},
            {"name": "新營區", "code": "新營區"},
            {"name": "後壁區", "code": "後壁區"},
            {"name": "白河區", "code": "白河區"},
            {"name": "東山區", "code": "東山區"},
            {"name": "六甲區", "code": "六甲區"},
            {"name": "下營區", "code": "下營區"},
            {"name": "柳營區", "code": "柳營區"},
            {"name": "鹽水區", "code": "鹽水區"},
            {"name": "善化區", "code": "善化區"},
            {"name": "大內區", "code": "大內區"},
            {"name": "山上區", "code": "山上區"},
            {"name": "新市區", "code": "新市區"},
            {"name": "安定區", "code": "安定區"}
          ]
        },
        {
          name: '高雄市',
          code: '高雄市',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "楠梓區", "code": "楠梓區"},
            {"name": "左營區", "code": "左營區"},
            {"name": "鼓山區", "code": "鼓山區"},
            {"name": "三民區", "code": "三民區"},
            {"name": "鹽埕區", "code": "鹽埕區"},
            {"name": "前金區", "code": "前金區"},
            {"name": "新興區", "code": "新興區"},
            {"name": "苓雅區", "code": "苓雅區"},
            {"name": "前鎮區", "code": "前鎮區"},
            {"name": "旗津區", "code": "旗津區"},
            {"name": "小港區", "code": "小港區"},
            {"name": "鳳山區", "code": "鳳山區"},
            {"name": "大寮區", "code": "大寮區"},
            {"name": "鳥松區", "code": "鳥松區"},
            {"name": "林園區", "code": "林園區"},
            {"name": "仁武區", "code": "仁武區"},
            {"name": "大樹區", "code": "大樹區"},
            {"name": "大社區", "code": "大社區"},
            {"name": "岡山區", "code": "岡山區"},
            {"name": "路竹區", "code": "路竹區"},
            {"name": "橋頭區", "code": "橋頭區"},
            {"name": "梓官區", "code": "梓官區"},
            {"name": "彌陀區", "code": "彌陀區"},
            {"name": "永安區", "code": "永安區"},
            {"name": "燕巢區", "code": "燕巢區"},
            {"name": "田寮區", "code": "田寮區"},
            {"name": "阿蓮區", "code": "阿蓮區"},
            {"name": "茄萣區", "code": "茄萣區"},
            {"name": "湖內區", "code": "湖內區"},
            {"name": "旗山區", "code": "旗山區"},
            {"name": "美濃區", "code": "美濃區"},
            {"name": "內門區", "code": "內門區"},
            {"name": "杉林區", "code": "杉林區"},
            {"name": "甲仙區", "code": "甲仙區"},
            {"name": "六龜區", "code": "六龜區"},
            {"name": "茂林區", "code": "茂林區"},
            {"name": "桃源區", "code": "桃源區"},
            {"name": "那瑪夏區", "code": "那瑪夏區"}
          ]
        },
        {
          name: '屏東縣',
          code: '屏東縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "屏東市", "code": "屏東市"},
            {"name": "潮州鎮", "code": "潮州鎮"},
            {"name": "東港鎮", "code": "東港鎮"},
            {"name": "恆春鎮", "code": "恆春鎮"},
            {"name": "萬丹鄉", "code": "萬丹鄉"},
            {"name": "長治鄉", "code": "長治鄉"},
            {"name": "麟洛鄉", "code": "麟洛鄉"},
            {"name": "九如鄉", "code": "九如鄉"},
            {"name": "里港鄉", "code": "里港鄉"},
            {"name": "鹽埔鄉", "code": "鹽埔鄉"},
            {"name": "高樹鄉", "code": "高樹鄉"},
            {"name": "萬巒鄉", "code": "萬巒鄉"},
            {"name": "內埔鄉", "code": "內埔鄉"},
            {"name": "竹田鄉", "code": "竹田鄉"},
            {"name": "新埤鄉", "code": "新埤鄉"},
            {"name": "枋寮鄉", "code": "枋寮鄉"},
            {"name": "新園鄉", "code": "新園鄉"},
            {"name": "崁頂鄉", "code": "崁頂鄉"},
            {"name": "林邊鄉", "code": "林邊鄉"},
            {"name": "南州鄉", "code": "南州鄉"},
            {"name": "佳冬鄉", "code": "佳冬鄉"},
            {"name": "琉球鄉", "code": "琉球鄉"},
            {"name": "車城鄉", "code": "車城鄉"},
            {"name": "滿州鄉", "code": "滿州鄉"},
            {"name": "枋山鄉", "code": "枋山鄉"},
            {"name": "霧臺鄉", "code": "霧臺鄉"},
            {"name": "瑪家鄉", "code": "瑪家鄉"},
            {"name": "泰武鄉", "code": "泰武鄉"},
            {"name": "來義鄉", "code": "來義鄉"},
            {"name": "春日鄉", "code": "春日鄉"},
            {"name": "獅子鄉", "code": "獅子鄉"},
            {"name": "牡丹鄉", "code": "牡丹鄉"},
            {"name": "三地門鄉", "code": "三地門鄉"}
          ]
        },
        {
          name: '台東縣',
          code: '台東縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "臺東市", "code": "臺東市"},
            {"name": "成功鎮", "code": "成功鎮"},
            {"name": "關山鎮", "code": "關山鎮"},
            {"name": "長濱鄉", "code": "長濱鄉"},
            {"name": "池上鄉", "code": "池上鄉"},
            {"name": "東河鄉", "code": "東河鄉"},
            {"name": "鹿野鄉", "code": "鹿野鄉"},
            {"name": "卑南鄉", "code": "卑南鄉"},
            {"name": "大武鄉", "code": "大武鄉"},
            {"name": "綠島鄉", "code": "綠島鄉"},
            {"name": "太麻里鄉", "code": "太麻里鄉"},
            {"name": "海端鄉", "code": "海端鄉"},
            {"name": "延平鄉", "code": "延平鄉"},
            {"name": "金峰鄉", "code": "金峰鄉"},
            {"name": "達仁鄉", "code": "達仁鄉"},
            {"name": "蘭嶼鄉", "code": "蘭嶼鄉"}
          ]
        },
        {
          name: '花蓮縣',
          code: '花蓮縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "花蓮市", "code": "花蓮市"},
            {"name": "鳳林鎮", "code": "鳳林鎮"},
            {"name": "玉里鎮", "code": "玉里鎮"},
            {"name": "新城鄉", "code": "新城鄉"},
            {"name": "吉安鄉", "code": "吉安鄉"},
            {"name": "壽豐鄉", "code": "壽豐鄉"},
            {"name": "光復鄉", "code": "光復鄉"},
            {"name": "豐濱鄉", "code": "豐濱鄉"},
            {"name": "瑞穗鄉", "code": "瑞穗鄉"},
            {"name": "富里鄉", "code": "富里鄉"},
            {"name": "秀林鄉", "code": "秀林鄉"},
            {"name": "萬榮鄉", "code": "萬榮鄉"},
            {"name": "卓溪鄉", "code": "卓溪鄉"}
          ]
        },
        {
          name: '宜蘭縣',
          code: '宜蘭縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "宜蘭市", "code": "宜蘭市"},
            {"name": "頭城鎮", "code": "頭城鎮"},
            {"name": "羅東鎮", "code": "羅東鎮"},
            {"name": "蘇澳鎮", "code": "蘇澳鎮"},
            {"name": "礁溪鄉", "code": "礁溪鄉"},
            {"name": "壯圍鄉", "code": "壯圍鄉"},
            {"name": "員山鄉", "code": "員山鄉"},
            {"name": "冬山鄉", "code": "冬山鄉"},
            {"name": "五結鄉", "code": "五結鄉"},
            {"name": "三星鄉", "code": "三星鄉"},
            {"name": "大同鄉", "code": "大同鄉"},
            {"name": "南澳鄉", "code": "南澳鄉"}
          ]
        },
        {
          name: '澎湖縣',
          code: '澎湖縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "馬公市", "code": "馬公市"},
            {"name": "湖西鄉", "code": "湖西鄉"},
            {"name": "白沙鄉", "code": "白沙鄉"},
            {"name": "西嶼鄉", "code": "西嶼鄉"},
            {"name": "望安鄉", "code": "望安鄉"},
            {"name": "七美鄉", "code": "七美鄉"}
          ]
        },
        {
          name: '金門縣',
          code: '金門縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "金城鎮", "code": "金城鎮"},
            {"name": "金湖鎮", "code": "金湖鎮"},
            {"name": "金沙鎮", "code": "金沙鎮"},
            {"name": "金寧鄉", "code": "金寧鄉"},
            {"name": "烈嶼鄉", "code": "烈嶼鄉"},
            {"name": "烏坵鄉", "code": "烏坵鄉"}
          ]
        },
        {
          name: '連江縣',
          code: '連江縣',
          children: [
            {name: '請選擇區域', code: ''},
            {"name": "南竿鄉", "code": "南竿鄉"},
            {"name": "北竿鄉", "code": "北竿鄉"},
            {"name": "莒光鄉", "code": "莒光鄉"},
            {"name": "東引鄉", "code": "東引鄉"}
          ]
        },
      ],
      formData: {
        "name": "",
        "gender": "",
        "age": "",
        "phone": "",
        "joinArea": "",
        "marriageStatus": "",
        "mail": "",
        "city": "",
        "area": "",
        "zipcode": "",
        "address": "",
        "content": "",
        'verificationcode': '',
        isGraphicError: false
      },
      areaList: [],
      isAgree: false,
      graphic: process.env.API_ROOT + API.createValidateGraphic + '?id=',
      graphicId: '',
      isSubmit: false,
      isShowClause: false,
      text: "",
      isGraphicError: false,
      isShowPopup: false
    }
  },
  mounted() {
    this.getGraphicId();
  },
  methods: {
    submitForm(e) {
      this.isSubmit = true;
      if (this.isAgree) {
        if(!this.formData.verificationcode){
          return false;
        }
        this.$store.commit('showLoading');
        this.$post(API.postJoin, {verificationcodeId: this.graphicId, ...this.formData})
          .then(res => {
            this.$store.commit('hideLoading');
            if (res.code === 200) {
              this.isSubmit = false;
              this.isShowPopup = true;
              this.formData = {
                "name": "",
                "gender": "",
                "age": "",
                "phone": "",
                "joinArea": "",
                "marriageStatus": "",
                "mail": "",
                "city": "",
                "area": "",
                "zipcode": "",
                "address": "",
                "content": "",
                "verificationcode": ''
              }
              this.getGraphicId();
              this.isAgree = false;
            } else if (res.code === 502) {
              this.isGraphicError = true;
              this.getGraphicId();
            }
          })
      }
      return;
    },
    changeCity(city) {
      const [addressItem] = this.address.filter((item) => {
        return city === item.name
      });
      this.formData.area = '';
      this.areaList = addressItem.children;
    },
    getGraphicId() {
      this.graphicId = new Date().getTime() + '' + Math.random(1000);
    },
    openClausePopUp() {
      this.isShowClause = true;
    },
    closePopup(value) {
      this.isShowClause = value;
    }
  },
  components: {
    'clausePopup': ClausePopup,
    'vue-select': VueSelect
  }
}
</script>
<style scoped lang="scss">
.mt-35 {
  margin-top: 35px;
}

.feedback {
  width: 96%;
  height: auto;
  margin: 0 auto;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: #FFFFFF;
  border-radius: 20px;

  .feedback-conten {
    padding: 60px 122px 95px 129px;

    .tip {
      width: 100%;
      padding-bottom: 15px;

      p {
        color: #000000;
        font-size: 18px;
      }

    }

    .row {
      margin-top: 40px;

      .col-md-6, .col-md-12 {
        padding: 0 22px;
        font-size: 16px;
        .graphic {
          img {
            width: 76px;
            margin: 0 5px;
            vertical-align: middle;
          }

          input {
            width: calc(100% - 130px);
          }

          .reload-img {
            display: inline-block;
            width: 33px;
            height: 33px;
            background: url("../../assets/images/refer.svg") no-repeat center;
            background-size: 100% auto;
            vertical-align: middle;
            cursor: pointer;
          }
        }

        div {
          width: calc(100% - 105px);
          display: inline-block;

          input, select, textarea {
            width: 100%;
            height: 48px;
            line-height: 48px;
            border: 1px solid #908782;
            border-radius: 24px;
            padding-left: 30px;
          }

          textarea {
            height: 225px;
            resize: none;
            outline: none;
          }
        }

        label {
          width: 100px;
          vertical-align: top;
          padding-top: 10px;
          position: relative;
          letter-spacing: 1px;

          em {
            margin-right: 6px;
            color: red;
          }
        }

        &.col-md-12 {
          div {
            width: calc(100% - 105px);
          }
        }

        .address-box {
          width: calc(100% - 105px);
          display: inline-block;
        }

        .chekox-box2 {
          div {
            width: auto;
            margin-right: 10px;
            padding-top: 10px;

            label {
              width: auto;
              padding-top: 0;
              margin-left: 6px;
            }
          }

          input[type='checkbox'], input[type='radio'] {
            height: 25px;
            width: 25px;
            line-height: 25px;
            border: 1px solid #000000;
            border-radius: 5px;
            background-color: #FFFFFF;
            padding-left: 0;
          }
        }
      }

      .col-md-4 {
        max-width: calc((100% - 74px) / 3);
        padding: 0;
        vertical-align: middle;
        height: 48px;

        &:nth-child(2) {
          margin: 0 33px;
        }
      }
    }
  }
}

.error {
  position: relative;

  .error-tip {
    margin-left: 20px;
    margin-top: 4px;
    color: #D00717;
    font-size: 14px;
    font-weight: 500;
    position: absolute;
  }
}

.agree {
  text-align: center;
  margin-top: 98px;

  .error {
    width: 100%;
    text-align: center;

    .error-tip {
      width: 100%;
      margin: 0;
    }
  }

  a {
    color: #908782;
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
  }

  .agree-box {
    position: relative;
    padding-left: 10px;

    input[type=checkbox] {
      position: absolute;
      left: 0;
      box-sizing: border-box;
      height: 24px;
      width: 23px;
      border: 1px solid #979797;
      border-radius: 5px;
      background-color: #FFFFFF;
      cursor: pointer;
    }

    span {
      padding-left: 28px;
    }
  }

}

.agree-submit-btn {
  text-align: center;
  margin-top: 26px;

  button {
    height: 70px;
    width: 350px;
    line-height: 70px;
    background-color: #F5AC2D;
    border: 0;
    border-radius: 35px;
    cursor: pointer;
    color: #1F2329;
    font-size: 20px;
    font-weight: 500;
    outline: none;
    &:hover{
      background: #f7a61b;
    }
  }
}

@media (max-width: 1080px) {
  .m-mb-23 {
    margin-bottom: 20px;
  }
  .feedback {
    width: calc(100% - 16px);
    padding: 0 17px;
    margin: 0 auto;

    .feedback-conten {
      padding: 30px 0 35px;

      .tip {
        .w-6 {
          width: 100%;
          border: none;
          padding: 0;
          font-size: 15px;
          letter-spacing: 0.5px;
          line-height: 28px;
          margin-bottom: 30px;
        }
      }

      .row {
        margin: 0;
        .col-md-6{
          &:nth-child(2n){
            padding-left:20px;
          }
        }
        .mt-35 {
          margin-top: 0;
        }

        .col-md-4 {
          max-width: 100%;
          width: 100%;
          margin: 0 0 20px 0;

          &:nth-child(2) {
            margin: 0 0 20px 0;
          }
        }

        .col-md-6, .col-md-4 {
          margin-bottom: 20px;
        }

        .col-md-6, .col-md-12, .col-md-4 {
          padding: 0;
          div, .address-box {
            width: calc(100% - 85px);

            select, input[type=text] {
              height: 45px;
              line-height: 43px;
              font-size: 14px;

            }
            textarea{
              height: 160px;
            }

            &.upload {
              width: 100%;
            }
          }

          .graphic {
            vertical-align: top;

            input {
              width: calc(100%);
              margin-bottom: 20px;
            }
          }

          label {
            width: 80px;
            font-size: 15px;
            letter-spacing: 0.47px;
            line-height: 25px;
            margin-bottom: 15px;
          }

          &.textarea-box {
            width: 100%;

            label {
              width: 80px;
            }

            div {
              width: 100%;
            }
          }

          &.col-md-12 {
            label {
              width: 80px;
            }

            div {
              width: calc(100% - 85px);
            }

            .address-box {
              .col-md-4 {
                width: 100%;
              }
            }
          }
        }

        .div-122 {
          height: auto;
          line-height: 43px;
        }
      }
    }
  }
  .agree {
    margin-top: 30px;
  }
  .agree-submit-btn {
    button {
      max-width: 220px;
      height: 45px;
      line-height: 43px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 1.2px;
    }
  }
}
@media (max-width:767px){    
  .feedback .feedback-conten .row .col-md-6{
    &:nth-child(2n){
      padding-left:0;
    }
  }
  .error.graphic .error-tip{
    margin-top:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/default/Join.vue